import { CalendarStep } from 'common/components/entities/Calendar/calendar-step'
import {
  BookingCalendarSteps,
  EventTimeZoneTypeEnum,
} from 'common/components/entities/Calendar/constants'
import {
  CommonBookingCalendarContainerUi,
  CommonBookingCalendarWrapperUi,
} from 'common/components/entities/Calendar/ui/common-calendar-container-ui'
import { BookingCalendarInterface } from 'common/types/entities/BookingCalendarInterface'
import { managementSelectors, useManagement } from 'publisher/store'
import React from 'react'
import { useBookingCalendarParams } from './use-booking-calendar-params'

interface PreviewBookingCalendarProps {
  entity: BookingCalendarInterface
}

export const PreviewBookingCalendar = ({
  entity,
}: PreviewBookingCalendarProps) => {
  const {
    event,
    timeSlots,
    isEventFetching,
    selectedDate,
    selectedTimeZone,
    selectedTimeSlot,
    selectedLocationId,
    handleChangeField,
    onMonthSelect,
    globalFontFamily,
    globalMobileFontSize,
    globalFontSize,
    activeStep,
  } = useBookingCalendarParams({ entity, isIframePreview: true })
  const isDesktop = useManagement(managementSelectors.isDesktop)

  return (
    <CommonBookingCalendarWrapperUi style={{ padding: '5px 0' }}>
      <CommonBookingCalendarContainerUi
        padding={entity.padding}
        margin={entity.margin}
        mobilePadding={entity.mobilePadding}
        mobileMargin={entity.mobileMargin}
        color={entity.color}
        mobileColor={entity.mobileColor}
        fontFamily={globalFontFamily}
        fontSize={globalFontSize}
        mobileFontSize={globalMobileFontSize}
        isThankYouStep={activeStep === BookingCalendarSteps.ThankYouStep}
        isDateSelected={!!selectedDate}
      >
        <CalendarStep
          availabilitySlots={timeSlots}
          selectedDate={selectedDate}
          onMonthSelect={onMonthSelect}
          onDateSelect={date => {
            handleChangeField('date', date)
            handleChangeField('timeSlot', '')
          }}
          selectedTimeSlot={selectedTimeSlot}
          onTimeSlotSelect={timeSlot => handleChangeField('timeSlot', timeSlot)}
          selectedTimeZone={selectedTimeZone}
          onTimeZoneSelect={tz => {
            if (event?.displayTimezoneType !== EventTimeZoneTypeEnum.Fixed) {
              handleChangeField('timeZone', tz)
            }
          }}
          selectedLocationId={selectedLocationId}
          onLocationSelect={locationId => {
            handleChangeField('eventLocationId', locationId)
          }}
          event={event}
          isEventLoading={isEventFetching}
          isMobile={!isDesktop}
          entity={entity}
          color={entity.color}
          mobileColor={entity.mobileColor}
          fontFamily={globalFontFamily}
          fontSize={globalFontSize}
          mobileFontSize={globalMobileFontSize}
        />
      </CommonBookingCalendarContainerUi>
    </CommonBookingCalendarWrapperUi>
  )
}
